import { Row } from 'components/Row';
import Column from 'components/Column';
import { Image } from 'components/Image';
import { UtilityText } from 'components/Typography';
import styled from 'styled-components/macro';

export const Container = styled.div`
  margin: auto;
  width: 100%;
  overflow: hidden;
  border-radius: 5px 5px 0 0;
  box-shadow: ${({ theme }) => `0px 0px 10px 0px ${theme.shadows.black(0.08)}`};
  margin-bottom: 8px;
`;

export const Subtitle = styled(UtilityText)`
  color: ${({ theme }) => theme.shadows.black(0.5)};
`;

export const StyledImage = styled(Image)`
  width: 55px;
  height: 55px;
  border-radius: 3px;
`;

export const Content = styled(Column)<{ $pressable?: boolean }>`
  align-self: center;
  ${({ $pressable }) => $pressable && 'cursor: pointer;'}
  grid-column: 3;
  grid-row: 1;
`;

export const ShowMoreLessContent = styled(Column)`
  align-self: center;
  cursor: pointer;
  grid-column: 4;
  grid-row: 1;
  text-align: right;
`;

export const CandidatePhoto = styled(Row)`
  grid-column: 2;
  grid-row: 1;
`;

export const CardContent = styled(Row)<{ $isSelected?: boolean; $detailVisible?: boolean }>`
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ $detailVisible }) => ($detailVisible ? '5px 5px 0 0' : '5px')};
  border-width: 3px 0 0 0;
  border-style: solid;

  ${({ $isSelected, theme }) =>
    $isSelected
      ? `
      ${`border-image: linear-gradient(${theme.gradients.inkToDarkGradient({})});`}
      border-image-slice: 1;
    `
      : `
      border-color: ${theme.colors.white}
    `}
`;

export const ShowMoreLessRow = styled(Row)<{
  $isSelected?: boolean;
  $detailVisible?: boolean;
  $detailOpen?: boolean;
}>`
  ${({ $detailVisible, $detailOpen }) =>
    $detailVisible &&
    $detailOpen &&
    `
    border-radius: 0 0 5px 5px;
    padding: 8px;
    justify-content: flex-end;
  `}
  display: ${({ $detailVisible }) => ($detailVisible ? 'flex' : 'none')};
  background: ${({ theme }) => theme.colors.white};
  text-wrap: nowrap;
  &:hover {
    span {
      color: ${({ theme }) => theme.colors.electricBlue};
      text-decoration: underline;
    }

    svg path {
      fill: ${({ theme }) => theme.colors.electricBlue} !important;
    }
  }
`;

export const CandidateGrid = styled(Column)`
  width: -webkit-fill-available;
  width: 100%;
  grid-template-columns: 23px 55px 4fr 1fr;
  grid-template-rows: auto auto;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 12px;
  column-gap: 7px;
  margin-bottom: -12px;
`;

export const TextsColumn = styled(Column)`
  width: -webkit-fill-available;
  gap: 9px;
`;

export const AlignTop = styled.span`
  align-self: start;
  line-height: 0;
  margin-bottom: 3px;
  margin-top: 4px;
`;

export const GridCheckbox = styled(Row)`
  align-self: center;
  grid-column: 1;
  grid-row: 1;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const GhostRectangle = styled.div`
  background: ${({ theme }) => theme.colors.softGray};
`;

export const PlusContainer = styled.div<{ $color?: string }>`
  background: ${({ theme, $color }) => $color || theme.colors.electricBlue};
  border-radius: 50%;
  padding: 0px 3px 2px;
`;

export const GhostLabel = styled(GhostRectangle)`
  height: 16px;
  width: 90px;
`;

export const GhostContent = styled(GhostRectangle)`
  height: 19px;
  width: 70px;
`;
